<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align: center;"><i>For Don and Roger, Compadres, Friends</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?7cae72e8